import _ from "lodash";

import React from "react";

//material icons
import Done from "@material-ui/icons/Done";
import Close from "@material-ui/icons/Close";
import DateRange from "@material-ui/icons/DateRange";
import PhoneTalk from "@material-ui/icons/PhoneInTalk";
import Warning from "@material-ui/icons/Warning";
import Alarm from "@material-ui/icons/Alarm";
import Picture from "@material-ui/icons/PictureInPictureAlt";
import Record from "@material-ui/icons/RecordVoiceOver";

import chartsStyle from "assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx";
import withStyles from "material-ui/styles/withStyles";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// core
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import StatsCard from "components/Cards/StatsCard.jsx";
import CustomHeaderCard from "components/Cards/CustomHeaderCard.jsx";
import CustomStatsCard from "components/Cards/CustomStatsCard.jsx";
import Table from "components/Table/Table";
import { formatAMPM } from "../utils";

const style = {
    customHeader: {
        marginLeft: "10px !important"
    }
}


class ServerStats extends React.Component{
    constructor(props){
        super(props);
        this.renderCount = 0;
    }
    render(){
        this.renderCount = this.renderCount + 1;
        const { data } = this.props;
        let d = new Date(); 
        let currentTime = formatAMPM(d);

        let serverStatus = (data.asterisk_status != "down") ? {"icon": Done, "color": "green", 
                      "statIcon": DateRange, "desc": "Running"} :
                {"icon": Close, "color": "red", 
                      "statIcon": DateRange, "desc": "Down"};

        return(
            <div>
            <hr />
            <GridContainer>
                <br />
                <ItemGrid xs={12} sm={6} md={3} lg={3}>
                  <br />
                  <StatsCard
                    icon={serverStatus.icon}
                    iconColor={serverStatus.color}
                    title="Asterisk Status"
                    small={serverStatus.desc}
                    statIcon={serverStatus.statIcon}
                    statText={`Since ${currentTime}`}
                  />
                </ItemGrid>
                <ItemGrid xs={12} sm={12} md={3} lg={3}>
                  <br />
                  <CustomStatsCard
                    iconColor="green"
                    icon={Picture}
                    title="Channels"
                    small={(data.channels == null) ? 0 : data.channels}
                    statIcon={Warning}
                    statText=""
                  />
                </ItemGrid>
                <ItemGrid xs={12} sm={12} md={3} lg={3}>
                  <br />
                  <CustomStatsCard
                    iconColor="blue"
                    icon={Record}
                    title="Active"
                    small={(data.active == null) ? 0 : data.active}
                    statIcon={Warning}
                    statText=""
                  />
                </ItemGrid>
                <ItemGrid xs={12} sm={12} md={3} lg={3}>
                  <br />
                  <CustomStatsCard
                    iconColor="red"
                    icon={Alarm}
                    title="Alarms"
                    small={(data.alarms == null) ? "None" : data.alarms}
                    statIcon={Warning}
                    statText=""
                  />
                </ItemGrid>
               
            </GridContainer>
            <GridContainer>
                <ItemGrid xs={12} sm={12} md={5} lg={3}>
                    <br />
                    <br />
                    <CustomHeaderCard
                        headerColor="purple"
                        icon={PhoneTalk}
                        className={style.customHeader}
                        content={
                            <Table
                              hover
                              tableHeaderColor="warning"
                              tableHead={["Name"]}
                              tableData={[
                                (data.calls == null) ? ["None"] : data.calls
                              ]}
                            />
                        }
                    />
                </ItemGrid>
            </GridContainer>
            </div>
        )
    }
}

export default withStyles(chartsStyle)(ServerStats);


// WEBPACK FOOTER //
// ./src/views/stats/components/ServerStats.js